<template>
  <div class="tc-configurator-right-sidebar-items">
    <div class="tc-sidebar-right-items-head">
      Комплектующие:
    </div>
    <div class="tc-sidebar-right-items-body tc-thin-scrollbar">
      <div class="tc-sidebar-right-items-body-inner">
        <ResultCaseCard v-if="storeCaseConfiguration.selectedCaseModel&&!isHardCase"
                        :item="storeCaseConfiguration.getSelectedCaseData"/>
        <ResultItemCard v-for="item in caseItems"
                        :item="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import ResultItemCard from '@/UI/RightSidebar/Components/ResultItemCard.vue';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import ResultCaseCard from '@/UI/RightSidebar/Components/ResultCaseCard.vue';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';

export default {
  name: 'RightSidebarItems',
  components: {
    ResultCaseCard,
    ResultItemCard,
  },
  setup() {
    const storeCaseConfiguration = useStoreCaseConfiguration();
    return {
      storeCaseConfiguration,
    };
  },
  computed: {
    isHardCase() {
      if (!this.storeCaseConfiguration.selectedCaseModel) return false;
      return this.storeCaseConfiguration.selectedCaseModel.toLowerCase().includes('hard');
    },
    caseItems() {
      const items = [ ...this.storeCaseConfiguration.caseItems ];
      const itemsCountMap = {};
      const itemsIdsGroupMap = {};
      let key, keyShort, id;
      //Если выбранный шкаф - HARD, то добавить в results корпус и раму отдельно
      if (this.isHardCase) {
        const caseModels = {
          '1000': [  'frame_hard_1000', 'frame_hard_1000','body_hard_1000' ],
          '2000': [ 'frame_hard_2000', 'frame_hard_2000', 'body_hard_2000' ],
        };
        const modelType = this.storeCaseConfiguration.selectedCaseModel.includes('1000') ? '1000' : '2000';
        caseModels[modelType].forEach(itemId => items.unshift({ prototypeId: itemId }));
      }

      items.forEach(obj => {
        key = obj.prototypeId;
        id = obj.idGroup;
        if (id !== undefined && !isNaN(id)) {
          //для чпу: один тип полок, разные prototypeId, так как разные модели в зависимости от номера секции =>
          //считаю по keyShort для указания верного количества полок
          keyShort = key.split('_s')[0];
          !itemsIdsGroupMap[keyShort] ? itemsIdsGroupMap[keyShort] = key : key = itemsIdsGroupMap[keyShort];
        }

        if (itemsCountMap[key]) {
          itemsCountMap[key]++;
        } else {
          itemsCountMap[key] = 1;
        }
      });

      // Создаем новый массив для хранения результатов
      const result = [];

      // Перебираем массив объектов и добавляем только уникальные, добавляя свойство count
      items
          .filter(obj => itemsCountMap[obj.prototypeId] && !obj.noVisible)
          .forEach(obj => {
            if (!result.some(item => item.prototypeId === obj.prototypeId)) {
              result.push({ ...obj, count: itemsCountMap[obj.prototypeId] });
            }
          });

      return result;
    },
  },
};
</script>

<style scoped lang="scss">
@import "CSS/scrollbar";

.tc-configurator-right-sidebar-items {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  background-color: #ffffff;
  overflow: hidden;
  pointer-events: all;
  padding: 15px 0 15px 15px;
  flex-direction: column;
  gap: 15px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-sidebar-right-items-head {
  font-weight: 600;
  font-size: 16px;
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #333333;
}

.tc-sidebar-right-items-body {
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  overflow-x: hidden;

}

.tc-sidebar-right-items-body-inner {
  display: flex;
  height: max-content;
  width: 100%;
  overflow-y: hidden;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
}
</style>
